import { Chip } from "@mui/material";
import { STATUS_OPTIONS_PRIVATE } from "../../constants/status";

export default function GetValidityChip({ status }) {
  const cfg = STATUS_OPTIONS_PRIVATE.find((s) => s.value === status);
  return cfg ? (
    <Chip
      label={cfg.label}
      sx={{
        bgcolor: cfg.color,    // aquí el color de fondo (hex o nombre MUI)
        color: "white",        // texto blanco para que contraste (ajusta si quieres)
        "& .MuiChip-icon": {
          color: "white",      // icono también blanco
        },
      }}
      icon={cfg.icon}
      size="small"
    />
  ) : null;
}
